// /src/store/tasksManagment
//
// Tâches de fond visibles dans le bandeau du header, à côté des uploads
// (cf. TaskManager.tsx). Pour l'instant : le transcodage d'un média (Video ou
// AudioSlideshow — MediaRow.tsx traite les deux de façon générique).
//
// Alimenté par MediaRow.tsx, qui sonde déjà la progression pour l'incrustation
// sur sa propre ligne : ce store ne fait que recevoir une copie de ce sondage
// pour l'afficher aussi dans le bandeau global. Une tâche ne vit donc que tant
// qu'au moins une ligne de média l'a poussée — cf. le commentaire de
// TaskManager.tsx sur cette limite.

// Actions types
export const UPSERT_TRANSCODING_TASK = 'UPSERT_TRANSCODING_TASK';
export const REMOVE_TRANSCODING_TASK = 'REMOVE_TRANSCODING_TASK';

export enum TranscodingTaskStatus {
  TRANSCODING = 'transcoding',
  COMPLETED   = 'completed',
  FAILED      = 'failed',
}

export interface TranscodingTaskState {
  mediaId  : number;
  label    : string;
  progress : number; // 0-100
  status   : TranscodingTaskStatus;
  startTime: Date;
  /** Figé au premier constat de COMPLETED, comme startTime à la première apparition. */
  endTime? : Date;
}

export interface TasksState {
  transcodingTasks: { [mediaId: number]: TranscodingTaskState };
}

export const initialState: TasksState = {
  transcodingTasks: {},
};

export interface UpsertTranscodingTaskAction {
  type: typeof UPSERT_TRANSCODING_TASK;
  payload: {
    mediaId : number;
    label   : string;
    progress: number;
    status  : TranscodingTaskStatus;
  };
}

export interface RemoveTranscodingTaskAction {
  type: typeof REMOVE_TRANSCODING_TASK;
  payload: {
    mediaId: number;
  };
}

export type TasksActionTypes =
  | UpsertTranscodingTaskAction
  | RemoveTranscodingTaskAction;
